import React from "react";
import "./tarjeta.css";

const tarjeta = () => {
  return (
    <div className="container">
      <div className="card">
        <img src="img.jpg" alt="Mamá y yo" />
        <h1>Feliz Día, Mamá</h1>
        <h5>Para ti mama ...</h5>
        <p>
          Tu amor incondicional que ha sido mi luz en días oscuros y tu
          sabiduría ha sido mi guía en los momentos de confusión.
        </p>
        <p>
          Gracias por enseñarme a reír cuando las cosas se ponen difíciles y por
          mostrarme como se fuerte incluso en los momentos más desafiantes.
        </p>
        <p>
          Tu resiliencia y tu corazón generoso son un ejemplo para míu todos los
          días. En este día de las madres, quiero que sepas lo especial que eres
          para mí. No solo hoy, sino todos los días, te honro y te agradezco por
          todo lo que haces.
        </p>

        <p>
          Quiero darte las gracias por todo lo que has hecho por mí, pero estoy
          seguro que estarás pensando o diciéndome: "esa era mi responsabilidad
          como madre hijo". Pero aquí es donde te digo que te equivocas, porque,
          como no decirte gracias si me trajiste a la vida y me has dado todo lo
          que necesito para ser feliz, pero no solo eso, sino que me has
          arropado en la cama varias veces, me has hecho de comer, me ayudabas
          con las tareas, me dabas consejos, me enseñaste a ser una mejor
          persona, ser fuerte, valiente, humilde, respetuoso, amable,
          agradecido, honesto, cariñoso. Me enseñaste que un puño cerrado se usa
          para sostener fuertemente no para golpear.
        </p>
        <p>
          Me enseñaste a convertir una casa en un hogar, me enseñaste a amar a
          mis enemigos, me enseñaste a ensanchar primero mi espíritu antes de
          ensanchar mi bolsillo, me enseñaste gratitud, honor, fidelidad.
        </p>
        <p>
          Me cuidaste cuando estuve enfermo, me enseñaste a ser independiente,
          me levantaste en brazos cuando tuve miedo. Sonreíste aunque estarás
          enferma. Me diste valores y moral, me llamaste hijo y lo cumpliste mas
          allá del titulo.
        </p>
        <p>
          Estuve enfermo y tus besos me curaron; te veía triste y preocupada
          pero siempre respondías: "no es nada hijo, estoy bien". Me diste
          regalos y el mejor de todos fue tu amor.
        </p>
        <p>
          Se que hoy trato a mi novia como una princesa porque fui educado por
          una reina y asi mismo podría seguir escribiéndote un libro entero de
          todo lo que has hecho por mi, pero no terminaría nunca.
        </p>
        <p>
          No todos los héroes llevan capa, el mío tiene arrugas y lunares en la
          cara. Tu eres mi mama, la que con un abrazo te saca todo lo malo y con
          un beso te truena toda la tristeza y con una sonrisa te borra la
          amargura.
        </p>
        <p>
          Dios en Éxodo 20:12 nos manda a honrar a nuestros padres y nos promete
          largura de días y que todo nos saldrá bien. Pero mami, aunque esa
          promesa no existiera y esa recompensa tampoco, yo de todos sigo
          brindando por tu vida, porque se que todo lo que haces lo haces por
          amor y eso es lo que me hace feliz.
        </p>
        <p>
          Gracias por ser mi madre, mi amiga, mi confidente, mi todo. Gracias
          por ser mi héroe. Gracias por ser tú. Gracias por ser mi mamá.
        </p>
        <h5> Feliz Día de las Madres, Mamá. Te amo.</h5>
        <img src="img2.jpg" alt="Mamá y yo" />
        <p>Con mucho cariño, tu Hijo. 💖</p>
      </div>
      <footer className="footer">
        <p>
          Created with 🧉 byㅤ
          <a href="https://juangonzalez.com.ar">Juan Gonzalez</a> &copy; 2024
        </p>
      </footer>
    </div>
  );
};

export default tarjeta;
